export function getCurrentAdminPerformerSlug() {
  try {
    const performer = JSON.parse(
      window.sessionStorage.getItem("paranoidi_auth_performer") || "{}"
    );

    const slug = String(performer?.slug || "").trim();

    if (slug) {
      return slug;
    }
  } catch {
    // Käytetään fallbackia alla.
  }

  return "demo";
}

export function getCurrentAdminPublicPath() {
  return `/p/${getCurrentAdminPerformerSlug()}`;
}

// Vanhojen importtien takia pidetään nämä vielä olemassa,
// mutta uusia linkkejä ei saa enää rakentaa näillä.
export const CURRENT_ADMIN_PERFORMER_SLUG = "demo";
export const CURRENT_ADMIN_PUBLIC_PATH = "/p/demo";